module.exports = __webpack_public_path__ + "media/unipod/icon-tanking-white-26b006bb.svg";